import type { IClientApis } from '@d-orca/shared/client/hooks';
import { commsApi } from '@apis/comms';
import { notificationsApi } from '@apis/notifications';
import { issuesApi } from '@apis/monitor';
import { storageApi } from '@apis/storage';

// The API objects shared hooks read through ClientApisProvider (mounted once in
// main.tsx). Built here at module load, never in render: the provider relies on
// this object keeping one identity for the app's lifetime.
export const clientApis: IClientApis = {
  comms: commsApi,
  issues: issuesApi,
  notifications: notificationsApi,
  storage: storageApi,
};
